import callApi from "./callApi";
import { moduleName } from "../store/state";

const actions = {
  ...callApi,
  setLoadMore: ({ commit }, payload) => {
    commit("setLoadMore", payload);
  },
  setFilter: ({ commit }, payload) => {
    commit("setFilter", payload);
  },
  setResponse: ({ commit }, payload) => {
    commit("setResponse", payload);
  },
  resetPagination: ({ commit }) => {
    commit("resetPagination");
  },

  resetDataList: ({ commit }) => {
    commit("resetDataList");
  },

  setLastItemToView: ({ commit }, payload) => {
    commit("setLastItemToView", payload);
  },

  resetPage: ({ commit }, payload) => {
    commit("resetPage", payload);
  },
  resetList: ({ commit }, payload) => {
    commit("resetList", payload);
  },
};

export default actions;
